
var target;
var control;
import Swiper from 'Swiper';
import 'swiper/css/swiper.min.css';

$(document).ready(function () {
  initSwiperPet();
});

function viewportIsMobile(width) {
  return (width < 1025);
}
$(function () {
  $('.tab-wrapper').each(function (index, value) {
    $(this).find('li').first().trigger('click');
  });
});

function activeTab(obj) {
  $(obj).parent('.tab').find('li').removeClass('active');
  $(obj).addClass('active');
  var id = $(obj).find('a').attr('href');
  $(obj).parents('.tab-wrapper').find('.tab-item').hide();
  $(id).show();
}

$('.tab li').click(function () {
  activeTab(this);
  return false;
});


window.initSwiperPet = initSwiperPet;
function initSwiperPet() {
  if ($('#swiperNews').length > 0) {
    var swiper = new Swiper("#swiperNews", {
      pagination: {
        el: ".swiper-pagination",
      },
    });
  }
}